/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react'
import { Icon } from '@pff-consumer/tweed-ui/atoms/icon/icon.web'
import { checkoutHooks } from '@pff-consumer/data-provider/lib/checkout/checkout.hooks'
import { SVGGroup } from '@pff-consumer/utils'
import { useStyles } from './customer-email.styles'

const { useCheckoutActions, useEmailErrorMessage, useEmail, useNewsLetterPreference } = checkoutHooks

export const CustomerEmail = () => {
  const { updateEmail, toggleNewLetterPreference } = useCheckoutActions()
  const errorMessage = useEmailErrorMessage()
  const email = useEmail()
  const isErrorTextField = !!errorMessage
  const styles = useStyles({ isErrorTextField })
  const hasOptedInForNewsLetter = useNewsLetterPreference()

  const handleEmail = (e: any) => {
    updateEmail(e.target.value)
  }

  return (
    <div className={styles.oneStepCheckoutEmailContainer}>
      <label
        className={styles.oneStepCheckoutEmailLabel}
        htmlFor='email'
      >
        Email<span className={styles.mandatoryIndicator}>*</span>
      </label>
      <input
        id='email'
        type='email'
        placeholder='Email'
        defaultValue={email}
        onBlur={handleEmail}
        className={styles.oneStepCheckoutEmail}
      />
      {errorMessage && (
        <div
          className={styles.oneStepCheckoutEmailError}
          data-testid='error-message'
        >
          <Icon
            name='field-error'
            group={SVGGroup.Icons}
            width={12}
            height={12}
          />
          {errorMessage}
        </div>
      )}
      <div className={styles.newsletterCheckboxContainer}>
        <input
          type='checkbox'
          className={styles.newsletterCheckbox}
          id='newsletterCheckbox'
          checked={hasOptedInForNewsLetter}
          onChange={toggleNewLetterPreference}
        />
        <label
          className={styles.newsletterCheckboxLabel}
          htmlFor='newsletterCheckbox'
        >
          Sign me up to receive exclusive promotions, news, and other features from PFF via email
        </label>
      </div>
    </div>
  )
}
